import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, ListItemText, MenuItem, Typography } from '@mui/material'
import { RouteImage } from '../../../../../assets/routeImage'

// COMPONENT
import Navbar from '../../../Navbar'
import Header from '../../../Header'
import { ButtonOutlined } from '../../../../../component/mui-custom/MuiCustom'
import * as styled from '../../../style/main.style'
import TableCustom from '../../../../../component/table/tableCustom'
import TableRowCommon from '../../../../../component/table/TableRowCommon'
import HeaderTopicTable from '../../../../../component/header-table/HeaderTopicTable'
import { disableStyleButtonMui } from '../../../../../utils/disableStyleButton'
import ModalCustom from '../../../../../component/modal/ModalCustom'
import AddClusters from './add-clusters/AddClusters';
import EditClusters from './edit-clusters/EditClusters';

// API
import { ClustersApi, getClusters, updateCluster } from '../../../../../api/clusters/clusters.api';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice';
import Loading from '../../../../../component/loading/Loading';
import FilterSelect from '../../../../../component/select/filterSelect'

type Props = {}
const MissionType: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    const idFiscalYear = useSelector((state: any) => state?.fiscalYear?.idFiscalYear);
    const permission = useSelector((state: any) => state?.permission?.permission);

    const [clusters, setClusters] = useState<any[]>([]);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalItems, setTotalItems] = useState<number>(Number);
    const [isShowModal, setIsShowModal] = useState<boolean>(false);
    const [isShowModalEdit, setIsShowModalEdit] = useState<boolean>(false);
    const [clusterId, setClusterId] = useState<number>(Number);
    const [keyword, setKeyword] = useState<string>("");

    const handleToggleModal = () => setIsShowModal(!isShowModal)
    const handleToggleModalEdit = () => setIsShowModalEdit(!isShowModalEdit)

    // API
    const handleChangeStatus = async (idClusters: number, objData: any, status: string) => {
        dispatch(setLoading())
        let condition: updateCluster = {
            clustersName: objData?.clustersName,
            clustersNo: objData?.clustersNo,
            clustersStatus: status,
            idFiscalYear: objData?.idFiscalYear
        }
        await ClustersApi.updateClusters(idClusters, condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    console.log(res.data)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
            .finally(() => handleGetCluster())
    }
    const handleGetCluster = useCallback(async () => {
        dispatch(setLoading())
        let condition: getClusters = {
            limit: pageLimit,
            page: page
        }
        if (keyword) condition = { ...condition, keyword: keyword }
        if (idFiscalYear !== 0) condition = { ...condition, idFiscalYear: idFiscalYear }
        await ClustersApi.getClusters(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    // console.log(res.data)
                    setClusters(res?.data?.result?.items);
                    setTotalItems(res?.data?.result?.meta?.totalItems)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }, [keyword, page, pageLimit])

    const headCells = [
        {
            id: "RANK", width: 90, disablePadding: false, align: 'left', label:
                <HeaderTopicTable align='start' minWidth='1px' text='ลำดับ' />
        },
        {
            id: "MISSION", disablePadding: false, align: 'left', label:
                <HeaderTopicTable align='start' text='ภารกิจ' />
        },
        {
            id: "STATUS", disablePadding: false, width: 90, align: 'center', label:
                <HeaderTopicTable align='center' text='สถานะ' />
        },
        {
            id: "EDIT", disablePadding: false, align: "left", label: ""
        }
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { clustersName, clustersNo, idClusters, clustersStatus } =
            objData;

        const objRenderData = {
            key: idClusters,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "left", label: clustersNo },
                { option: "TEXT", align: "left", label: clustersName },
                {
                    option: "TEXT", align: "left", width: 90, label:
                        <FilterSelect
                            disabled={permission?.find((list: any) => list?.code === "MissionType.Edit")?.permit === false}
                            headingNormal
                            renderValue={() =>
                                <ListItemText className='relative text-center'>
                                    {clustersStatus === t("STATUS.ACTIVE") ? (
                                        <Typography
                                            className='text-light_success after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-light_success after:rounded-[50%]'>
                                            {t("STATUS.ACTIVE")}
                                        </Typography>
                                    ) : (
                                        <Typography
                                            className='text-danger after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-danger after:rounded-[50%]'>
                                            {t("STATUS.INACTIVE")}
                                        </Typography>
                                    )}
                                </ListItemText>
                            }

                            label={t('STATUS.LABEL')}
                            selectId="select-strategy-status"
                            value={clustersStatus}
                            labelId="label-strategy-status"
                            onchange={(event: React.ChangeEvent<HTMLSelectElement>) => handleChangeStatus(idClusters, objData, event.target.value)}
                            options={[
                                <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                    <Typography className='text-light_success'><li>{t("STATUS.ACTIVE")}</li></Typography>
                                </MenuItem>,
                                <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                    <Typography className='text-danger'><li>{t("STATUS.INACTIVE")}</li></Typography>
                                </MenuItem>
                            ]}
                        />
                },
                {
                    option: "COMPONENT",
                    align: "right",
                    width: 10,
                    component:
                        <div className='w-full flex justify-end gap-5'>
                            {permission?.find((list: any) => list?.code === "MissionType.Edit")?.permit === true && (
                                <Button
                                    onClick={() => {
                                        handleToggleModalEdit()
                                        setClusterId(idClusters)
                                    }}
                                    startIcon={<img src={RouteImage.editPen} />}
                                    sx={disableStyleButtonMui}>{"แก้ไข"}</Button>
                            )}
                        </div>
                }
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    useEffect(() => {
        handleGetCluster()
    }, [keyword, page, pageLimit])

    return (
        <styled.ContainerHome>
            {isShowModal && (
                <ModalCustom
                    enableExit={handleToggleModal}
                    maxHeight='auto'
                    heading={"เพิ่มภารกิจ"}
                    alignHeader='center'
                    component={<AddClusters fetchData={handleGetCluster} toggleModal={handleToggleModal} />}
                />
            )}
            {isShowModalEdit && (
                <ModalCustom
                    enableExit={handleToggleModalEdit}
                    maxHeight='auto'
                    heading={"แก้ไขภารกิจ"}
                    alignHeader='center'
                    component={<EditClusters clusterId={clusterId} fetchData={handleGetCluster} toggleModal={handleToggleModalEdit} />}
                />
            )}
            <Navbar />
            {isLoading === true && <Loading />}
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <section className='flex justify-start items-start md:justify-between flex-col md:flex-row md:items-center gap-3'>
                        <Typography className='text-primary' variant='h4'>
                            {`ปีงบประมาณ ${idFiscalYear === 0 ? '' : idFiscalYear} / ประเภทภารกิจ`}
                        </Typography>
                        {permission?.find((list: any) => list?.code === "MissionType.Create")?.permit === true && (
                            <ButtonOutlined
                                onClick={handleToggleModal}
                                sx={{ maxWidth: "75px" }}
                                startIcon={<img src={RouteImage.addButton} />} >
                                <Typography className='text-primary'>{t("BUTTON.ADD")}</Typography>
                            </ButtonOutlined>
                        )}
                    </section>

                    <section className='mt-8 w-full h-auto'>
                        {clusters && (
                            <TableCustom
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={""}
                                sortType="ASC"
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={clusters && clusters.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={() => { }}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        )}
                    </section>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default MissionType